module.exports = __webpack_public_path__ + "static/media/option2-4row.a0b0d26d.png";